import React from 'react'
import { CreateJobPositionFormTrainContainer } from '../../containers/Officer/CreateJobPositionFormTrainContainer'
export const CreateJobPositionFormTrainPage = () => {
  return (
    <CreateJobPositionFormTrainContainer />
  )
}
